import React, { useEffect } from 'react';
import Footer from '../components/Footer';

function PrivacyPolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <main className="legal-page">
        <div className="container">
          <h1 className="legal-page__title">Privacy Policy</h1>
          <p className="legal-page__updated">Last updated: March 2026</p>

          <section className="legal-page__section">
            <h2>1. Introduction</h2>
            <p>KBY Interactive Co., Ltd. ("we", "us", "our") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you visit our website.</p>
          </section>

          <section className="legal-page__section">
            <h2>2. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
              <li><strong>Contact Information:</strong> Name, email address, phone number, and company name when you submit our contact form.</li>
              <li><strong>Usage Data:</strong> Information about how you use our website, including pages visited and time spent.</li>
              <li><strong>Cookies:</strong> We use cookies to improve your browsing experience. See our Cookie Policy below.</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>3. How We Use Your Information</h2>
            <ul>
              <li>To respond to your inquiries and provide customer support</li>
              <li>To improve our website and services</li>
              <li>To send project-related communications</li>
              <li>To comply with legal obligations</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>4. Data Protection (PDPA)</h2>
            <p>We comply with the Personal Data Protection Act (PDPA) B.E. 2562 (2019) of Thailand. Your personal data will be processed lawfully, fairly, and transparently. You have the right to access, correct, delete, or restrict the processing of your personal data.</p>
          </section>

          <section className="legal-page__section">
            <h2>5. Data Sharing</h2>
            <p>We do not sell, trade, or transfer your personal information to third parties without your consent, except as necessary to provide our services or comply with legal requirements.</p>
          </section>

          <section className="legal-page__section">
            <h2>6. Cookies</h2>
            <p>Our website uses cookies to enhance your experience. You can control cookie settings through your browser. By continuing to use our site, you consent to our use of cookies.</p>
          </section>

          <section className="legal-page__section">
            <h2>7. Data Security</h2>
            <p>We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.</p>
          </section>

          <section className="legal-page__section">
            <h2>8. Your Rights</h2>
            <p>Under the PDPA, you have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Withdraw consent at any time</li>
              <li>File a complaint with the relevant authority</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>9. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at:</p>
            <p>
              <strong>KBY Interactive Co., Ltd.</strong><br />
              Email: thitisquall@gmail.com<br />
              Phone: 063-782-4516
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
